"use strict";
(self["webpackChunkmyvega1"] = self["webpackChunkmyvega1"] || []).push([[359],{

/***/ 4359:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initFileRouter)
/* harmony export */ });
/**
 * This is the main entry point for all of the bundle JS.
 * You can immediately hook up an HTML element by using one of the two specified categories:
 * [data-utility] or [data-component]
 * The JS file will run with the specified element being passed in as the wrapper
 * You need to attach a specific file path as the attribute value [data]
 *
 * @example
 *   <button
 *     data-utility="link-to"
 *     data-link="/blog/your-url"
 *   >
 *     Click me
 *   </button>
 *
 * You can also pass multiple file paths by comma separating them
 * @example
 *   <button
 *     data-utility="link-to,inline-toggle"
 *     data-link="/blog/your-url"
 *     data-toggle="#some-query"
 *   >
 *     Click me
 *   </button>
 *
 * File paths can also include a subfolder
 * @example
 *   <button data-utility="button/atc">
 *     Click me
 *   </button>
 */

// Instructs the system of which attributes to watch for
// Watches for and provided selector, then imports the related file
function initFileRouter({ $, fileRouter, barba, fileImporter }) {
  if (!fileRouter) return;

  const $barbaContainer = config.barbaEnabled ? $(document).find(barba.selectors.container) : $();
  const $watchContainer = config.barbaEnabled && $barbaContainer.length ? $barbaContainer : $(document)

  fileRouter.watchForSelectors.forEach(function ({ selector, path, fileName }) {
    $watchContainer.watchFor(selector, ($elements) => {
      if (!$elements.length) return

      $elements.each(function () {
        const targetElement = this
        const attribute = selector.replace('[', '').replace(']', '')
        const fileHandle = fileName || $(targetElement).attr(attribute)
        const splitHandles = fileHandle.split(',')

        splitHandles.forEach(function (handle) {
          fileImporter({ path, fileName: handle, element: targetElement })
        })
      })
    })
  })
}

/***/ })

}]);